import * as rudderClient from 'rudder-sdk-js'

rudderClient.load(
  `${process.env.EXPO_PUBLIC_RUDDERSTACK_TOKEN}`,
  `${process.env.EXPO_PUBLIC_RUDDERSTACK_DATA_PLANE_URL}`,
)

// track com aviso de flush: na web o callback do SDK sinaliza que o evento
// saiu do navegador — quem navega para fora do domínio (window.location)
// precisa esperar por ele, senão o unload descarta o request pendente.
export const trackEvent = (
  event: string,
  properties?: Record<string, string | number | boolean | undefined>,
  onFlush?: () => void,
) => {
  if (onFlush) {
    rudderClient.track(event, properties ?? {}, onFlush)
    return
  }
  rudderClient.track(event, properties ?? {})
}

export { rudderClient }
